import { render, staticRenderFns } from "./SortOnMultipleColumns.vue?vue&type=template&id=115cd512&"
import script from "./SortOnMultipleColumns.vue?vue&type=script&lang=js&"
export * from "./SortOnMultipleColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports